import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";
import utilityVariables from "ui-v2/styles/utility_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue =
    semanticVariables?.[`semantic_icon_${color}`] ||
    utilityVariables?.[`utility_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.006 3.70504C19.193 3.63715 19.3454 3.49775 19.4296 3.31753C19.5138 3.13731 19.5229 2.93102 19.455 2.74404C19.3871 2.55706 19.2478 2.40472 19.0675 2.32051C18.8873 2.23631 18.681 2.22715 18.494 2.29504L6.00004 6.83804V3.00004C6.00004 2.80113 5.92102 2.61036 5.78037 2.46971C5.63972 2.32906 5.44895 2.25004 5.25004 2.25004H3.75004C3.55113 2.25004 3.36036 2.32906 3.21971 2.46971C3.07906 2.61036 3.00004 2.80113 3.00004 3.00004V7.93004L1.99404 8.29504C1.80706 8.36294 1.65472 8.50233 1.57051 8.68255C1.48631 8.86277 1.47715 9.06906 1.54504 9.25604C1.61294 9.44302 1.75233 9.59537 1.93255 9.67957C2.11277 9.76377 2.31906 9.77294 2.50604 9.70504L19.006 3.70504Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.019 11.114L18 5.66699V9.08799L22.006 10.545C22.193 10.6129 22.3453 10.7523 22.4295 10.9325C22.5137 11.1127 22.5229 11.319 22.455 11.506C22.3871 11.693 22.2477 11.8453 22.0675 11.9295C21.8873 12.0137 21.681 12.0229 21.494 11.955L21 11.775V20.25H21.75C21.9489 20.25 22.1397 20.329 22.2803 20.4697C22.421 20.6103 22.5 20.8011 22.5 21C22.5 21.1989 22.421 21.3897 22.2803 21.5303C22.1397 21.671 21.9489 21.75 21.75 21.75H2.25C2.05109 21.75 1.86032 21.671 1.71967 21.5303C1.57902 21.3897 1.5 21.1989 1.5 21C1.5 20.8011 1.57902 20.6103 1.71967 20.4697C1.86032 20.329 2.05109 20.25 2.25 20.25H3V11.121L3.019 11.114ZM18 20.25V10.684L19.5 11.23V20.25H18ZM9 14.25C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15V19.5C8.25 19.914 8.586 20.25 9 20.25H12C12.1989 20.25 12.3897 20.171 12.5303 20.0303C12.671 19.8897 12.75 19.6989 12.75 19.5V15C12.75 14.8011 12.671 14.6103 12.5303 14.4697C12.3897 14.329 12.1989 14.25 12 14.25H9Z"
        fill={colorValue}
      />
    </svg>
  );
};
